import {VuexModule, Module, Mutation, Action} from 'vuex-module-decorators';
import {loginService} from '@/services/login.service';
import {LoginDto, SignUpDto} from '@/services/LoginModels';
import {
  BV_OptionItemNumber,
  GuestUser,
  MemberInfo,
  PinxToken,
  PMSResGuestLogin,
  PMSResLogin,
  User,
  UserLogin,
} from '@/models';
import {AxiosResponse} from 'axios';
import _ from 'lodash';
import store from '@/store';
import SiteConst from '@/pages/MyPage/MyPageConst';
import {alertService} from '@/services/alert.service';
import router from '@/router';
// 로그인 참고
// https://www.bezkoder.com/vuex-typescript-jwt-auth/
import {PINX_TOKEN} from '@/util/Const';

const storeSelectedNumberMemberInfo = sessionStorage.getItem('selectedNumberMemberInfo');

//const pinxTokenSaved = localStorage.getItem('pinxToken');

@Module({namespaced: true})
class UserAuth extends VuexModule {
  private pinxAccessToken = ''; // refreshToken 으로 매번 갱신하는 액세스 토큰
  private signOutData? = ''; // signout 사유, 정상이면 비어 있거나 없음, refreshToken 실패시 resultCode(3000)
  //loggedIn : PMS 계정으로 로그인 했는지?
  //guestLogin : 비회원 예약과 같은 기능을 쓰기 위해 guest용으로 token 발급 했는지?
  private status = {loggedIn: false, guestLogin: false, memberCorpLogin: false};
  private user: User | null = null;
  private guestUser: GuestUser | null = null;
  private selectedNumberMemberInfo = storeSelectedNumberMemberInfo ? parseInt(storeSelectedNumberMemberInfo) : 0;

  // 개발서버에서 테스트 용도, 10초마다 한번씩 토큰 리프레시
  //private autoRefreshTokenTimeoutDuration = 10 * 1000;
  // 운영서버 로그인 토큰 정상 타임아웃 시간=30분, 25분마다 갱신
  get autoRefreshTokenTimeoutDuration() {
    const duration = 25 * 60 * 1000;
    // try {
    //   // 개발서버 로그인 토큰 수정된 타임아웃 시간=1분, 50초마다 갱신
    //   if (window.location.hostname.startsWith('localhost') || window.location.hostname.startsWith('devel-')) {
    //     duration = 50 * 1000;
    //   }
    // } catch (e) {
    //   console.log(e);
    // }
    return duration;
  }
  private autoRefreshTokenTimer = 0;
  private autoLogoutTimer = 0;
  private autoLogoutAlertTimer = 0;

  @Mutation
  clearAutoLogoutTimer() {
    if (this.autoLogoutTimer) {
      clearTimeout(this.autoLogoutTimer);
      this.autoLogoutTimer = 0;
    }
    if (this.autoLogoutAlertTimer) {
      clearTimeout(this.autoLogoutAlertTimer);
      this.autoLogoutAlertTimer = 0;
    }
  }

  @Mutation
  updateAutoLogoutTimer(timer: number) {
    this.autoLogoutTimer = timer;
  }
  @Mutation
  updateAutoLogoutAlertTimer(timer: number) {
    this.autoLogoutAlertTimer = timer;
  }

  @Action
  setAutoLogoutTimer() {
    if (this.isLoggedIn) {
      this.context.commit('clearAutoLogoutTimer');
      const duration = 30 * 60 * 1000;
      //const duration = 10 * 1000;
      const timerValue = setTimeout(() => {
        this.context.dispatch('signOut', 'autologout');
      }, duration);
      this.context.commit('updateAutoLogoutTimer', timerValue);

      const duration2 = 25 * 60 * 1000;
      //const duration2 = 5 * 1000;
      const timerValue2 = setTimeout(() => {
        this.context.dispatch('checkRefreshToken');
      }, duration2);

      this.context.commit('updateAutoLogoutAlertTimer', timerValue2);
    }
  }

  @Action
  checkRefreshToken() {
    if (this.isLoggedIn) {
      const extrMsg =
        '장시간 사이트 이용이 없어 정보보안을 위해 로그아웃 합니다.\n계속 이용하시려면 로그인 연장 버튼을 클릭하시기 바랍니다.\n※ 5분 경과 후, 자동 로그아웃 됩니다. ';
      const duration = 5 * 60 * 1000;
      //const duration = 5 * 1000;
      const modalId = 'checkRefreshToken';
      setTimeout(() => {
        alertService.hideMsgBoxConfirm(modalId);
      }, duration);
      alertService.showConfirm(extrMsg, undefined, modalId, '로그아웃', '로그인 연장').then(res => {
        if (res) {
          this.context.dispatch('signOut', 'autologout');
        } else {
          this.context.dispatch('setAutoLogoutTimer');
        }
      });
    }
  }

  @Mutation
  clearAutoRefreshTokenTimer() {
    if (this.autoRefreshTokenTimer) {
      clearTimeout(this.autoRefreshTokenTimer);
      this.autoRefreshTokenTimer = 0;
    }
  }

  @Mutation
  updateAutoRefreshTokenTimer(timer: number) {
    this.autoRefreshTokenTimer = timer;
  }

  @Action
  setAutoRefreshTokenTimer() {
    this.context.commit('clearAutoRefreshTokenTimer');

    const timerValue = setTimeout(() => {
      this.context.dispatch('refreshToken');
    }, this.autoRefreshTokenTimeoutDuration);

    this.context.commit('updateAutoRefreshTokenTimer', timerValue);
  }

  @Mutation
  public loginSuccess(info: UserLogin): void {
    this.status.loggedIn = true;
    this.user = info.user;
    this.pinxAccessToken = info.pinxToken;
    localStorage.setItem(PINX_TOKEN, this.pinxAccessToken);
    // window.dispatchEvent(
    //   new CustomEvent('storage', {
    //     detail: {
    //       storage: localStorage.getItem(PINX_TOKEN),
    //     },
    //   }),
    // );
  }

  @Mutation
  public guestLoginSuccess(info: GuestUser): void {
    this.status.guestLogin = true;
    this.status.memberCorpLogin = false;
    this.guestUser = info;
    this.pinxAccessToken = info.pinxToken;
  }
  @Mutation
  public memberCorpLoginSuccess(info: GuestUser): void {
    this.status.memberCorpLogin = true;
    this.status.guestLogin = false;
    this.guestUser = info;
    this.pinxAccessToken = info.pinxToken;
  }

  @Mutation
  public loginFailure(): void {
    this.status.loggedIn = false;
    this.user = null;
    this.pinxAccessToken = '';
  }

  @Mutation
  public logout(signOutData?: string): void {
    localStorage.setItem(PINX_TOKEN, '');

    this.status.loggedIn = false;
    this.user = null;
    this.pinxAccessToken = '';
    sessionStorage.removeItem('selectedNumberMemberInfo');
    this.selectedNumberMemberInfo = 0;
    this.signOutData = signOutData;
  }

  @Mutation
  public registerSuccess(): void {
    this.status.loggedIn = false;
  }

  @Mutation
  public registerFailure(): void {
    this.status.loggedIn = false;
  }

  @Mutation
  public updateToken(tokenObj?: PinxToken): void {
    if (!tokenObj) {
      this.context.commit('logout');
      return;
    }
    this.pinxAccessToken = tokenObj.pinxToken;
    //localStorage.setItem('pinxToken', this.pinxAccessToken);
  }

  // TODO : 토큰 만료시간전 (25분?) silent refreshToken 수행 하는 타이머 수행하기
  @Action({rawError: true})
  login(loginDto: LoginDto): Promise<AxiosResponse<PMSResLogin>> {
    return loginService.login(loginDto).then(
      response => {
        if (response.data.resultCode == '0000') {
          // XSS 공격에 대한 대비로 pinxToken은 localStorage에 저장하지 않는다.
          // pinxRefreshToekn 은 JS로 접근 불가능한 cookie 로 저장됨
          const user = _.omit(response.data.obj, ['pinxToken', 'pinxRefreshToken']);
          this.context.commit('loginSuccess', {
            user,
            pinxToken: response.data.obj.pinxToken,
          });

          this.context.dispatch('setAutoRefreshTokenTimer');
          this.context.dispatch('setAutoLogoutTimer');
        }
        return Promise.resolve(response);
      },
      (error: any) => {
        this.context.commit('loginFailure');
        const message =
          (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        return Promise.reject(message);
      },
    );
  }

  @Action({rawError: true})
  guestLogin(): Promise<AxiosResponse<PMSResGuestLogin>> {
    return loginService.guestLogin().then(
      response => {
        if (response.data.resultCode == '0000') {
          this.context.commit('guestLoginSuccess', response.data.obj);
          this.context.dispatch('setAutoRefreshTokenTimer');
        }
        return Promise.resolve(response);
      },
      (error: any) => {
        const message =
          (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        return Promise.reject(message);
      },
    );
  }

  @Action({rawError: true})
  memberCorpLogin(): Promise<AxiosResponse<PMSResGuestLogin>> {
    return loginService.memberCorpLogin().then(
      response => {
        if (response.data.resultCode == '0000') {
          this.context.commit('memberCorpLoginSuccess', response.data.obj);
          this.context.dispatch('setAutoRefreshTokenTimer');
        }
        return Promise.resolve(response);
      },
      (error: any) => {
        const message =
          (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        return Promise.reject(message);
      },
    );
  }

  @Action
  async initLogin() {
    try {
      const response = await this.context.dispatch('refreshToken');
      if (response) {
        await this.context.dispatch('updateUser');
      }
    } catch (e) {
      // TODO : 쿠키에 아무것도 없이 호출했을때 400 error 발생함.
    }
  }

  @Action({rawError: true})
  async refreshToken() {
    const response = await loginService.refreshToken();
    const data = response.data;
    if (data.resultCode === '0000') {
      const tokenObj = data.obj as PinxToken;
      this.context.commit('updateToken', {
        pinxToken: tokenObj.pinxToken,
      });

      this.context.dispatch('setAutoRefreshTokenTimer');
      return tokenObj;
    } else {
      await this.context.dispatch('signOut', data.resultCode);
      // TODO : 여기에 다음 코드를 삽입하면 무한루프 되므로 주의!!! 페이지 리프레싱이 일어나지 않도록 한다.
      // window.location.href = '/p/login';
      return null;
    }
  }

  @Action
  async updateUser() {
    if (!this.pinxAccessToken) return;

    try {
      const res = await loginService.userMyInfo();
      if (res.data.resultCode !== '0000') {
        this.context.commit('logout');
        return;
      }
      this.context.commit('loginSuccess', {
        user: res.data.obj as User,
        pinxToken: this.pinxAccessToken,
      });
    } catch (e) {
      console.error(e);
    }
  }

  @Action
  async signOut(signOutStatus?: string) {
    await loginService.logout();
    this.context.commit('clearAutoRefreshTokenTimer');
    this.context.commit('clearAutoLogoutTimer');
    this.context.commit('logout', signOutStatus);
  }

  @Action({rawError: true})
  snsLogIn(userData: any): void {
    //this.context.commit('loginSuccess', userData);
    const user = _.omit(userData, ['pinxToken', 'pinxRefreshToken']);
    this.context.commit('loginSuccess', {
      user,
      pinxToken: userData.pinxToken,
    });
  }

  @Action({rawError: true})
  register(signUpDto: SignUpDto): Promise<any> {
    return loginService.userJoin(signUpDto).then(
      (response: any) => {
        this.context.commit('registerSuccess');
        return Promise.resolve(response.data);
      },
      (error: any) => {
        this.context.commit('registerFailure');
        const message =
          (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        return Promise.reject(message);
      },
    );
  }

  get isLoggedIn(): boolean {
    return this.status.loggedIn;
  }

  get signOutStatus() {
    return this.signOutData;
  }

  get isGuestLoggedIn(): boolean {
    return this.status.guestLogin;
  }

  get isMemberCorpLogin(): boolean {
    return this.status.memberCorpLogin;
  }

  get pinxToken(): string | null {
    return this.pinxAccessToken;
  }

  get loginUser(): User | null {
    return this.user;
  }

  @Mutation
  public updateSelectedNumberMemberInfo(selectedNumber: number): void {
    this.selectedNumberMemberInfo = selectedNumber;
    sessionStorage.setItem('selectedNumberMemberInfo', selectedNumber.toString());
  }

  get selectedNumberMember(): number {
    return this.selectedNumberMemberInfo;
  }

  set selectedNumberMember(changedNumber: number) {
    this.selectedNumberMemberInfo = changedNumber;
  }

  get selectedMember(): MemberInfo | null {
    if (!this.isLoggedIn || !this.loginUser) return null;
    return this.loginUser!.memInfoArr[this.selectedNumberMemberInfo];
  }

  get menuAccessMap(): boolean[] {
    const defaultAccess = false;
    const accessMap = _.range(SiteConst.__LENGTH).map(x => defaultAccess);

    if (this.loginUser) {
      this.loginUser.memInfoArr.forEach(x => {
        if (x.memType === '001' || x.memType === '004' || x.memType === '006' || x.memType === '007') {
          accessMap[SiteConst.GOLF_CLUB_VALUE] = true;
          accessMap[SiteConst.HOTEL_PODO_VALUE] = true;
          accessMap[SiteConst.HOTEL_ANNEX_VALUE] = true;
          accessMap[SiteConst.DINING_VALUE] = true;
          accessMap[SiteConst.PLEISURE_VALUE] = true;
        } else if (x.memType === '003' || x.memType === '005') {
          accessMap[SiteConst.BIOTOPIA_VALUE] = true;
        } else if (x.memType === '012') {
          accessMap[SiteConst.HOTEL_PODO_VALUE] = true;
          accessMap[SiteConst.HOTEL_ANNEX_VALUE] = true;
          accessMap[SiteConst.DINING_VALUE] = true;
          accessMap[SiteConst.PLEISURE_VALUE] = true;
        }
      });
    }

    return accessMap;
  }
}

export default UserAuth;
